<div class="card-actions-item card-actions-item--{{ type }}">
    {{ text }}
</div>
